import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ElectricCarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"electric_car"}/>
}
